import { useAsset } from 'contexts/Assets'
import { useFairs } from 'contexts/Fairs'
import { AssetId } from 'types/Asset'
import { isLoadedAndNonNullish } from 'utils/loadable'

export default function useConversion(
  fromAssetId: AssetId | undefined,
  toAssetId: AssetId | undefined,
): number {
  const fromAsset = useAsset(fromAssetId)
  const toAsset = useAsset(toAssetId)

  const assets = []
  let fromId: number | undefined
  let fromMultiplier: number | undefined
  let toId: number | undefined
  let toMultiplier: number | undefined

  if (isLoadedAndNonNullish(fromAsset)) {
    const f = fromAsset.data
    fromId = f.contract_size ? f.contract_size.asset_id : f.id
    assets.push(fromId)
    fromMultiplier = f.contract_size ? f.contract_size.quantity : 1
  }
  if (isLoadedAndNonNullish(toAsset)) {
    const t = toAsset.data
    toId = t.contract_size ? t.contract_size.asset_id : t.id
    toMultiplier = t.contract_size ? t.contract_size.quantity : 1
    assets.push(toId)
  }

  const fairs = useFairs(assets)

  // This is ugly, but rules of hooks mean we can't call useFairs
  // conditionally, so we have to wait until here to bail out.
  if (
    typeof fromId === 'undefined' ||
    typeof toId === 'undefined' ||
    typeof fromMultiplier === 'undefined' ||
    typeof toMultiplier === 'undefined'
  ) {
    return NaN
  }

  if (fromId === toId) {
    // TODO: I think this could just be `return 1`?
    return fromMultiplier / toMultiplier
  }

  return (fairs[fromId] * fromMultiplier) / (fairs[toId] * toMultiplier)
}
